import { createContext, useContext, useState } from "react";
import { PolicySeverity } from "@repo/api/schemas/policies.schema";

interface PoliciesFormInitialValues {
  name?: string;
  description?: string;
  severity?: PolicySeverity;
  tags?: string[];
  evaluationCriteria?: string;
}

interface PoliciesFormState {
  name: string;
  setName: (v: string) => void;
  description: string;
  setDescription: (v: string) => void;
  severity: PolicySeverity;
  setSeverity: (v: PolicySeverity) => void;
  tags: string[];
  setTags: (v: string[]) => void;
  evaluationCriteria: string;
  setEvaluationCriteria: (v: string) => void;
}

const PoliciesFormContext = createContext<PoliciesFormState | null>(null);

export function PoliciesFormProvider({
  children,
  initialValues,
}: {
  children: React.ReactNode;
  initialValues?: PoliciesFormInitialValues;
}) {
  const [name, setName] = useState(initialValues?.name ?? "");
  const [description, setDescription] = useState(
    initialValues?.description ?? "",
  );
  const [severity, setSeverity] = useState<PolicySeverity>(
    initialValues?.severity ?? "low",
  );
  const [tags, setTags] = useState<string[]>(initialValues?.tags ?? []);
  const [evaluationCriteria, setEvaluationCriteria] = useState(
    initialValues?.evaluationCriteria ?? "",
  );

  return (
    <PoliciesFormContext.Provider
      value={{
        name,
        setName,
        description,
        setDescription,
        severity,
        setSeverity,
        tags,
        setTags,
        evaluationCriteria,
        setEvaluationCriteria,
      }}
    >
      {children}
    </PoliciesFormContext.Provider>
  );
}

export function usePoliciesForm() {
  const ctx = useContext(PoliciesFormContext);
  if (!ctx)
    throw new Error("usePoliciesForm must be used within PoliciesFormProvider");
  return ctx;
}
